import { ref, computed, watch } from '@vue/composition-api'
import {
  cloneDeep,
  each,
  flatMap,
  includes,
  isEmpty,
  isEqual,
  sumBy,
} from 'lodash'
import TableApi from '@/api/waiter/Table'

// NOTE: 卓の税サ・大計計算。延長候補一覧(useExtensionCandidates)と編集モーダルで共有する
export const calcTax = async ({ tableId, price }) => {
  const res = await TableApi.calcTax({ tableId, price })

  return res?.data
}

export const calcTotal = async ({ tableId, orderPrice }) => {
  const res = await TableApi.calcTotal({ tableId, orderPrice })

  return res?.data
}

export const getTotalTax = vendingHistoriesTemp => {
  return sumBy(vendingHistoriesTemp, vendingHistoryTemp => {
    return vendingHistoryTemp.size * vendingHistoryTemp.estimatedTaxPrice
  })
}

export const getRawOrderTotal = vendingHistoriesTemp => {
  return sumBy(vendingHistoriesTemp, vendingHistoryTemp => {
    const sellingPrice = Number(vendingHistoryTemp.value.sellingPrice) || 0
    const estimatedTaxPrice = Number(vendingHistoryTemp.estimatedTaxPrice) || 0

    return (sellingPrice + estimatedTaxPrice) * vendingHistoryTemp.size
  })
}

// NOTE: 単一の注文セット（編集中の延長内容）の概算を出す。
// 並列で走る計算が古い結果で新しい結果を上書きしないよう、候補一覧と同じシーケンス番号方式でレース制御する。
export default ({ tableId, vendingHistoriesTemp }) => {
  const estimatedTotal = ref(null)
  const isCalculating = ref(false)
  const taxSequence = ref(0)
  const totalSequence = ref(0)

  const taxEstimationTargets = computed(() => {
    return flatMap(vendingHistoriesTemp.value, vendingHistoryTemp => {
      const { sellingPrice, taxCharge } = vendingHistoryTemp.value

      return [sellingPrice, taxCharge]
    })
  })

  const totalEstimationTargets = computed(() => {
    return [
      ...flatMap(vendingHistoriesTemp.value, vendingHistoryTemp => {
        return [vendingHistoryTemp.estimatedTaxPrice, vendingHistoryTemp.value.sellingPrice, vendingHistoryTemp.size]
      }),
      vendingHistoriesTemp.value.length,
    ]
  })

  watch(() => cloneDeep(taxEstimationTargets.value), (newVal, prevVal) => {
    if (isEqual(newVal, prevVal)) return

    taxSequence.value += 1
    const currentSequence = taxSequence.value

    each(vendingHistoriesTemp.value, vendingHistoryTemp => {
      if (vendingHistoryTemp.value.taxCharge !== 'normal') {
        // eslint-disable-next-line no-param-reassign
        vendingHistoryTemp.estimatedTaxPrice = 0

        return
      }

      calcTax({ tableId: tableId(), price: vendingHistoryTemp.value.sellingPrice }).then(taxPrice => {
        if (taxSequence.value !== currentSequence) return

        // eslint-disable-next-line no-param-reassign
        vendingHistoryTemp.estimatedTaxPrice = taxPrice
      })
    })
  }, { immediate: true })

  watch(() => cloneDeep(totalEstimationTargets.value), (newVal, prevVal) => {
    if (isEmpty(newVal)) return
    // NOTE: 対象が空（明細0件）のときは計算しない。設定中プランが無い間の呼び出しがこれに当たる
    if (isEqual(newVal, [0])) return
    // NOTE: 税サ計算待ちの行があるうちは大計を出さない（途中の金額を見せない）
    if (includes(newVal, null)) return
    if (isEqual(newVal, prevVal)) return

    totalSequence.value += 1
    const currentSequence = totalSequence.value
    isCalculating.value = true

    calcTotal({ tableId: tableId(), orderPrice: getRawOrderTotal(vendingHistoriesTemp.value) }).then(total => {
      if (totalSequence.value !== currentSequence) return

      estimatedTotal.value = total
      isCalculating.value = false
    })
  }, { immediate: true })

  return {
    estimatedTotal,
    isCalculating,
  }
}
